import { render, staticRenderFns } from "./rectangle.vue?vue&type=template&id=cd830668&"
import script from "./rectangle.vue?vue&type=script&lang=ts&"
export * from "./rectangle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports